import { Component, OnInit,ViewChild } from '@angular/core';
import { ApiService } from '../services/api.service';
import { Proffesional, User } from '../model/dto';
import {BaseModel} from '../model/base.model';
import {UserModel} from '../model/user.model';
import { Router } from '@angular/router';
import {NgbModal, NgbModalRef, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';

@Component({
  selector: 'app-profesionalist',
  templateUrl: './profesionalist.component.html',
  styleUrls: ['./profesionalist.component.css'] 
})

export class ProfesionalistComponent implements OnInit {
  @ViewChild('content') content: ViewChild;
  subscription:any;
  public proffesionals:Proffesional[];
  public specialties:object;
  public pages:number[];
  public currentPage:number = 1;
  public currentLetterPage:string;
  public totalSearchResult:string;
  public total:number = 1;
  public filterName:string = 'Select filter';
  public filterValue:string = '';
  public isCollapsed:boolean = true;
  public isMAsearchCollapsed:boolean = true;
  public letters:string[] = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
  public usingLetterPaging:boolean=false;
  protected checkAllBoxes:boolean = false;
  public user:User;
  public adminLists:object[];
  public profSel:number = 0;
  public auxModal:NgbModalRef;
  public listname:number;  

  constructor(private _api:ApiService, private _baseModel:BaseModel, 
              private _userModel:UserModel, private modalService: NgbModal) {
    this.subscription = this._baseModel.docItem$.subscribe(
        item => this.changed(item)
    );
    this.user = this._userModel.user;
    if(this.user.isAdmin){
      this._api.getLists(this.user.PkUser)
        .subscribe(result=>this.onLists(result))
    }    
   }

   onLists(data:object){     
    this.adminLists = []
    var tot = data['length']
    for (var i = 0; i < tot; i++) {
     this.adminLists.push({label:data[i].Name, value:data[i].PkList});
    }
  }

  ngOnInit() {
    this._api.getSpecialties()
      .subscribe(result => this.onSpecialties(result));      
  }

  changed(item:Object){
    //console.log("Evt "+item['name']);//+":"+item['value'])
    //for(var prop in item['value']) console.log(prop+": "+item['value'][prop])
    let key:string = item["name"];
    let value:any = item["value"];
    if(key=="filterProf") {
      this._api.filterProf(value)
       .subscribe(result => this.onProffesionals(result))  
    }
    if(key=="searchProf"){
        this._api.profSearch(value)
         .subscribe(result => this.onProffesionals({data:result}))  
    }
  } 

  onSpecialties(data:object){
    this.specialties = {};
    for(var i:number = 0; i<data['length']; i++){
      this.specialties[data[i]['PkSpecialty']] = data[i]['Name'];
    }
    this._api.getProffesionals(1)
      .subscribe(result => this.onProffesionals(result)); 
  }

  checkAll(){
    this.checkAllBoxes = !this.checkAllBoxes;
    var tot:number = this.proffesionals.length
    for (var i = 0; i < tot; i++) {
      $('#'+this.proffesionals[i].PkProffesional).prop('checked', this.checkAllBoxes);
    }
  }


  addToList(){
    var tot:number = this.proffesionals.length
    this.profSel = 0;
    for (var i = 0; i < tot; i++) {
      if($('#'+this.proffesionals[i].PkProffesional).prop('checked')) this.profSel++;
    }
    this.auxModal = this.modalService.open(this.content);
  }

  saveToList(){
    var sel:number[] = [];
    var tot:number = this.proffesionals.length
    for (var i = 0; i < tot; i++) {
      if($('#'+this.proffesionals[i].PkProffesional).prop('checked')) {
        sel.push(this.proffesionals[i].PkProffesional)        
      }
    }
    
    this._api.saveToList(this.listname, sel)
      .subscribe(result=>this.onAddedToList(result))
  }

  onAddedToList(data:object){
    this.auxModal.close();
    if(data['success']==true) {
      var cant:number = data['data']['length']
      alert(data['message']);
    }
  }

  onProffesionals(data:object){
  	this.proffesionals = [];
  	this.total = parseInt(data['last_page']);
  	this.currentPage = parseInt(data['current_page']);
  	this.pages = [];
    var item:string;
    var proffesional:Proffesional
  	for (var i = 0; i<this.total; i++) this.pages.push(i+1);
     // console.log('Encuentra '+ data['data']['length']);
  	for (i = 0; i < data['data']['length']; i++) {
  		proffesional = data['data'][i] as Proffesional;
      proffesional.SpecialtyName = '';
      for (var z = 0; z < proffesional.specialty.length; z++) {
         item = this.specialties[proffesional.specialty[z]['FkSpecialty']] as string;
         proffesional.SpecialtyName += item+', '         
      }
     proffesional.SpecialtyName = proffesional.SpecialtyName.substr(0, proffesional.SpecialtyName.length-2);
  		this.proffesionals.push(proffesional);
  	}
    this.totalSearchResult = (data['total'])?data['total']:this.proffesionals.length
  }

  loadPage(page:number){
      this._api.getProffesionals(page)
  			.subscribe(result => this.onProffesionals(result));
  }

  filterPage(letter:string){
    this.usingLetterPaging = true;
    this.currentLetterPage = letter;
    console.log("this.currentLetterPage "+this.currentLetterPage)
    this._api.getProffesionalsByLetter(letter)
      .subscribe(result => this.onProffesionals(result));
  }

}